
import { Box, ButtonBase, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useGetConceptInvoiceInvoiceProductsQuery, useFinalizeInvoiceInvoiceProductsMutation, useDeclineInvoiceInvoiceProductsMutation } from "../../../../../newapi/financial/invoiceSlice";
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import MConfirmationWithValue from "../../../../../components/global/Modals/MConfirmationWithValue";
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import { showToastMessage, showToastMessagePostRequest, showToastMessageRequestError } from "../../../../../utils/toasts";
import { formatPrice } from "../../../../../utils/helpers";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
import { INVOICEMUTATIONS_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";

const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpRelationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails"));
const SpInvoiceDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails"));
const SpInvoiceInvoiceProductDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceInvoiceProductDetails/SpInvoiceInvoiceProductDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            {props.hasModifyPrivilege && (
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_concept_invoice')}
            </Shbutton>
            )}
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [
        INVOICEMUTATIONS_FILTER_KEYS.RELATION, INVOICEMUTATIONS_FILTER_KEYS.INVOICE_PRODUCT
    ],
};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [isRelationExtended, setIsRelationExtended] = useState(false);
    const [spRelationLoading, setSpRelationLoading] = useState();

    const [isOrderExtended, setIsOrderExtended] = useState(false);
    const [spOrderLoading, setSpOrderLoading] = useState();

    const [isProductExtended, setIsProductExtended] = useState(false);
    const [spInvoiceInvoiceProductDetails, setSpInvoiceInvoiceProductDetails] = useState();

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICE_CONCEPTPRODUCT_MANAGE])
    );

    const [finalizeInvoiceInvoiceProducts, {isLoading: isFinalizeLoading}] = useFinalizeInvoiceInvoiceProductsMutation();
    const handleFinalizeInvoiceInvoiceProducts = async () => {
        try {
            if (isFinalizeLoading) return;

            const updateObject = {
                invoiceInvoiceProductIds: selectedItems
            }

            const response = await finalizeInvoiceInvoiceProducts(updateObject).unwrap();
            showToastMessagePostRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t('finalize_failed'),t, err);
        }
    }

    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }
    
    const [open, setOpen] = useState(false);
    const confirmModal = {
        open: open,
        setOpen: setOpen,
        confirm: handleFinalizeInvoiceInvoiceProducts,
        data: {
            title: t("finalize_invoice_products"),
            content: t("are_you_sure_you_want_to_finalize_this_invoice_products")
        }
    } 
    
    const [declineInvoiceInvoiceProducts, {isLoading: isDeclineLoading}] = useDeclineInvoiceInvoiceProductsMutation();
    const handleDeclineInvoiceInvoiceProducts = async () => {
        try {
            if (isDeclineLoading) return;

            const updateObject = {
                invoiceInvoiceProductIds: selectedItems
            }

            const response = await declineInvoiceInvoiceProducts(updateObject).unwrap();
            showToastMessage("success", t("decline_succesfull"));
        } catch (err) {
            showToastMessageRequestError(t('decline_failed'),t, err);
        }
    }

    const [declineOpen, setDeclineOpen] = useState(false);
    const declineModal = {
        open: declineOpen,
        setOpen: setDeclineOpen,
        confirm: handleDeclineInvoiceInvoiceProducts
    } 

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const getRelationDetails = (params) => {
        if (!params?.row?.invoice?.relation) return;
    
        const newRelationId = parseInt(params.row.invoice.relation.id);
        // Only update state if the productId has actually changed
        if (relationIdRef.current !== newRelationId) {
            if(!spRelationLoading) {
                setSpRelationLoading(true);
            }
            setRelationId(newRelationId);
            relationIdRef.current = newRelationId; // Update the ref to the new value
        }
        setIsRelationExtended(true);
    };

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params?.row?.order?.id) return;
    
        const newOrderId = parseInt(params.row.order.id);
        // Only update state if the productId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spOrderLoading) {
                setSpOrderLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsOrderExtended(true);
    };

    const [invoiceId, setInvoiceId] = useState();
    const invoiceIdRef = useRef(invoiceId);
    
    const getInvoice = (params) => {
        if (!params?.row?.invoice) return;
    
        const newInvoiceId = parseInt(params.row.invoice.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceIdRef.current !== newInvoiceId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceId(newInvoiceId);
            invoiceIdRef.current = newInvoiceId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [invoiceProductId, setInvoiceProductId] = useState();
    const invoiceProductIdRef = useRef(invoiceProductId);
    
    const getInvoiceProduct = (params) => {
        if (!params?.row) return;
    
        const newInvoiceProductId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceProductIdRef.current !== newInvoiceProductId) {
            if(!spInvoiceInvoiceProductDetails) {
                setSpInvoiceInvoiceProductDetails(true);
            }
            setInvoiceProductId(newInvoiceProductId);
            invoiceProductIdRef.current = newInvoiceProductId; // Update the ref to the new value
        }
        setIsProductExtended(true);
    };

    const columns = [
        {
            field: "invoice.number",
            headerName: t("invoice"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getInvoice(params);
                };

                return (
                    <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.invoice?.number}</Text>
                    </Box>
                );
            }
        },
        {field: "invoice.relation.name", headerName: t("relation"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getRelationDetails(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.invoice?.relation?.name}</Text>
                </Box>
            );
        }},
        {field: "order.barcode", headerName: t("order"),flex:1,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            if (!params.row.order?.barcode) {
                return "";
            }
            const handleClick = (event) => {
                event.stopPropagation(); // Prevent click from propagating to the row
                getOrderDetails(params);
            };
            return (
                <Box sx={{height:1,display:"flex",alignItems:'center'}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.order?.barcode}</Text>
                </Box>
            );
        }},
        {
            field: "invoiceProduct.name", 
            headerName: t("name"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                return params.row.invoiceProduct.name;
              }
        },
        {
            field: "amount", 
            headerName: t("amount"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                return parseFloat(params.row.amount).toFixed(4).replace(/\.?0+$/, '');
              }
        },
        {
            field: "price", 
            headerName: t("price"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                return formatPrice(i18n,params.row.price);
              }
        },
        {
            field: "createdAt", 
            headerName: t("created_at"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.createdAt && params.row.createdAt !== null ? new Date(params.row.createdAt) : undefined;
              
                return (
                    <Text>
                        {date ? date.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                return (
                    <WarehouseInvoiceCard
                        onClick={() => getInvoice(params)}
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                    // <ShTextSkeleton/>
                )
            }
        },
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetConceptInvoiceInvoiceProductsQuery}
                gridActions={<GridActions></GridActions>} 
                title={t('invoicelines_to_accept')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[5].field,type:"DESC"}}
                columns={columns}
                rows={data}
                selectable={hasModifyPrivilege}
                setSelected={hasModifyPrivilege ? onSelected : undefined}
                selectedItems={hasModifyPrivilege ? selectedItems: undefined}
                onRowClick={getInvoiceProduct}
                selectedActions={
                    hasModifyPrivilege &&
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => declineModal.setOpen(true)} icon={<ClearIcon/>} text={t("reject")}/>
                        <DropdownButton onClick={() => confirmModal.setOpen(true)} icon={<CheckIcon/>} text={t("finalize")}/>
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => {
                    if(!hasModifyPrivilege || row.priceIncreases?.length > 0) {
                        return false;
                    }
                    return true;
                    // return row.priceIncreases?.length > 0
                }}
            >
            </ShDataGrid2>

            {spLoading && 
                <SpInvoiceDetails
                    invoiceId={invoiceId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }

            {spRelationLoading && 
                <SpRelationDetails
                    relationId={relationId}
                    isExtended={isRelationExtended}
                    setIsExtended={setIsRelationExtended}
                    // data={pickingJobData}
                /> 
            }

            {spInvoiceInvoiceProductDetails && 
                <SpInvoiceInvoiceProductDetails
                    invoiceInvoiceProductId={invoiceProductId}
                    isExtended={isProductExtended}
                    setIsExtended={setIsProductExtended}
                    // data={pickingJobData}
                /> 
            }

            {spOrderLoading && 
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isOrderExtended}
                    setIsExtended={setIsOrderExtended}
                    // data={pickingJobData}
                /> 
            }
            <MConfirmationWithValue
                open={confirmModal.open}
                handleClose={() => confirmModal.setOpen(false)}
                data={confirmModal.data}
                confirm={confirmModal.confirm}
            />
            <MConfirmation
                open={declineModal.open}
                handleClose={() => declineModal.setOpen(false)}
                title={t("decline_invoice_products_title")}
                subtitle={t("decline_invoice_products_subtitle")}
                confirm={declineModal.confirm}
            />
        </Box>
    );
}

export default All;